<template>
  <div class="container">
    <div class="box" v-if="isDel == 0 && loaded">
      <!-- 轮播 -->
      <div class="top_swiper">
        <swiper class="swiper" :options="options">
          <!-- <swiper-slide v-if="roomInfo.demoVideoUrl">
            <img class="play_icon" src="../../assets/images/Rectangle.png" @click="playVideo" />
            <video id="video" width="100%" height="100%" controls>
              <source :src="roomInfo.demoVideoUrl" type="video/mp4" />
              <source :src="roomInfo.demoVideoUrl" type="video/ogg" />您的浏览器不支持 video 标签。
            </video>
          </swiper-slide> -->
          <swiper-slide v-for="(item,index) in roomInfo.imageList" :key="index">
            <img :src="item.imgPath" class="slide-image" @click="viewBigPic(item.imgPath)" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <!-- <div
          class="indicator"
          v-if="roomInfo.imageList && roomInfo.imageList.length>0 && !(roomInfo.demoVideoUrl && current==0)"
        >
          <span>{{roomInfo.demoVideoUrl?current:(current+1)}}/{{roomInfo.imageList.length}}</span>
        </div>-->
      </div>
      <div class="meetingRoomMsg">
        <div class="priceBox">
          <span class="sign">￥{{roomInfo.unitPrice | priceT}}</span> / 小时起
        </div>
        <p class="activity_num_see">{{roomInfo.meetingRoomName}}</p>
        <div class="activity_time_roomInfo">
          <span class="activity_info_c activity_info_c1">面积{{roomInfo.area}}㎡</span>
          <span class="activity_info_c">座位{{roomInfo.meetingRoomNum}}人</span>
        </div>
        <!-- 分享 -->
        <img v-if="$store.state.common.theme==3" @click="shareFun" src="../../assets/images/themes_icon/icon_share_3.png" class="icon_share" />
        <img v-if="$store.state.common.theme!=3" @click="shareFun" src="../../assets/images/icon_share.png" class="icon_share">
      </div>
      <div class="activity_content">
        <div class="activity_time_box">
          <img v-if="$store.state.common.theme!=3" class="activity_time_box_img" src="../../assets/images/time.png" />
          <img v-if="$store.state.common.theme==3" class="activity_time_box_img" src="../../assets/images/themes_icon/time_3.png" />
          <p class="activity_time_box_text">开放时段 {{roomInfo.beginTime}}-{{roomInfo.endTime}}</p>
        </div>
        <div class="activity_address_box">
          <img v-if="$store.state.common.theme!=3" class="activity_time_box_img" src="../../assets/images/icon_site.png" />
          <img v-if="$store.state.common.theme==3" class="activity_time_box_img" src="../../assets/images/themes_icon/icon_site_3.png" />
          <p class="activity_time_box_text">{{roomInfo.address}}</p>
          <img v-if="$store.state.common.theme!=3"
            src="../../assets/images/btn_duplicate.png"
            class="btn_duplicate"
            @click="copyTradeCode"
            :data-clipboard-text="roomInfo.address"
          />
          <img v-if="$store.state.common.theme==3"
            src="../../assets/images/themes_icon/btn_duplicate_3.png"
            class="btn_duplicate"
            @click="copyTradeCode"
            :data-clipboard-text="roomInfo.address"
          />
        </div>
      </div>
      <!-- 简介 -->
      <div class="room_introduce">
        <span class="room_introduce_title_text">会议室简介</span>
        <!--  <p :class="[showMore?'':'over_two_lines']">{{roomInfo.describes}}</p>  -->
        <div class="room_introduce_html" v-html="htmlDescribes" >
        </div>
        <!-- <div class="showMore" @click="showMoreClick" v-if="moreLenth">
          <span>{{showMoreText}}</span>
          <img :class="[showMore?'rotate':'']" src="../../assets/images/icon_location_arrows.png" />
        </div> -->
      </div>
      <!-- 服务设施 -->
      <div class="room_introduce seviceList_wrap" v-if="labelList.length || chargeList.length">
        <template v-if="labelList.length">
          <p class="room_introduce_title_text">免费服务设施</p>
          <div class="seviceList">
            <div v-for="(item,index) in labelList" class="item" :key="index">
              <div class="seviceList_item">
                <img class="seviceList_item_img" v-if="$store.state.common.theme!=3" src="../../assets/images/icon_facility.png" />
                <img class="seviceList_item_img_3" v-if="$store.state.common.theme==3" src="../../assets/images/themes_icon/icon_facility_3.png" />
                <span>{{item | boardroomLabel}}</span>
              </div>
            </div>
          </div>
        </template>
        <template v-if="chargeList.length">
          <p class="room_introduce_title_text pay_service">付费服务</p>
          <div class="seviceList">
            <div v-for="(item,index) in chargeList" class="item" :key="index">
              <div class="seviceList_item">
                <img class="seviceList_item_img"  v-if="$store.state.common.theme!=3" src="../../assets/images/icon_facility.png" />
                <img class="seviceList_item_img_3"  v-if="$store.state.common.theme==3" src="../../assets/images/themes_icon/icon_facility_3.png" />
                <span>{{item.chargeName}}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- 退改规则 -->
      <div class="room_introduce" v-if="rules.length">
        <p class="room_introduce_title_text">退改规则</p>
        <div class="activeRulesBox" v-for="(item,index) in rules" :key="index">
          <p
            class="activeRules"
          >{{index + 1}}.截至会议室使用前开始前{{item.ruleTime}}{{ item.ruleType == 1 ? '小时' : '天'}}取消订单，退还该订单总金额的{{item.refundRatio}}%</p>
        </div>
      </div>

      <div class="room_AgreementCard" v-if="meetingAgreementList &&meetingAgreementList.length>0" >
         <p class="room_introduce_title_text">协议模板</p>
          <div class="room_Agreement_box" v-for="(item,index) in  meetingAgreementList" :key="index">
            <div class="room_Agreement_box1" @click="openFile(item.path,item.agreementName)">
               <img class="room_Agreement_icon" src="../../assets/images/icon_file.png" />
               <span class="room_Agreement_span" >{{item.agreementName}}</span>
               <img class="room_Agreement_icon1" src="../../assets/images/icon_indicator_next.png" />
            </div>
            <div class="room_Agreement_line"></div>

          </div>
      </div>


      <!-- 底部按钮 -->
       <template v-if="roomInfo.isOnlinePay"> 
      
          <div class="bottom_box button">
            <div :class="['btn_zx','btn_color_'+common.theme]" @click="callPhone">
              <img class="ask_img" :src="require(`../../assets/images/themes_icon/icon_iphone_${common.theme}.png`)" />
              <span class="ask_title">咨询</span>
            </div>
            <div :class="['btn_bm','btn_bm_color_'+common.theme]"  @click="goForm">
              <span class="apply_title">马上预订</span>
            </div>
          </div>
       </template>
       <template v-else>
          <div class="bottom_box bottom_box_big">
            <div :class="['btn_zx_big','btn_color_'+common.theme]" @click="callPhone">
              <img class="ask_img" :src="require(`../../assets/images/themes_icon/icon_iphone_${common.theme}.png`)" />
              <span class="ask_title">咨询</span>
            </div>
      </div>
        </template>
    </div>
    <div v-if="isDel != 0 && loaded" class="noMess">
      <img src="../../assets/images/img_unpublish.png"/>
      <span>该会议室已下架</span>
      <!-- <span class="btn" bindtap="toIndex">返回首页</span> -->
    </div>
    <!-- 查看大图 -->
    <fade-animation>
      <common-gallary :imgs="roomInfo.images" :curIndex="curIndex" v-show="showGallary" @close="handleGallaryClose"></common-gallary>
    </fade-animation>
    <share-iframe :showIframe="showIframe" @hideIframe="hideIframe"></share-iframe>
  </div>
</template>
<script>
import util from "../../utils/util";
import { mapState } from "vuex";
import { getMeetingRoomById, recordMeetingRoomView } from "../../utils/api";
import { createViewRequestId, recordViewWithRetry } from "../../utils/meetingRoomView";
import {serversHttp} from '../../utils/api.js';
import Clipboard from "clipboard";
import CommonGallary from "../../components/Gallary";
import FadeAnimation from "../../components/FadeAnimation";
import ShareIframe from '../../components/shareIframe';
import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'
export default {
  name: "roomDetail",
  components: {
    CommonGallary,
    FadeAnimation,
    ShareIframe
  },
  data() {
    return {
      curIndex:0,
      options: {
        pagination: ".swiper-pagination",
        paginationType: "fraction",
        observeParents: true,
        autoplay: false,
        observer: true
      },
      id: "",
      viewRequestId: "",
      roomActivationCount: 0,
      isRoomActive: false,
      roomInfo: {},
      labelList: [],
      rules: [],
      chargeList: [],
      showMore: false,
      moreLenth: false,
      showMoreText: "展开",
      showGallary: false,
      show: false,
      showIndex: false,
      current: 0,
      showIframe:false,
      isLock:0,//在线密码 1
      isDel:0,//是否删除
      loaded:false,
      payStatus: 1 ,//0无权限 1有权限
      meetingAgreementList:'',
      isAgreement:''
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    }),

    htmlDescribes(){
        var str 
        if(this.roomInfo.describes){
            var html1 ="<div style='width: 98%;padding: 10px; height:auto ; line-height: 135% white-space: normal;overflow: auto;word-wrap: break-word;'>"
            var html2 ='</div>'

            str = html1 + this.roomInfo.describes +  html2

        }


        return str

    },

  },
  filters: {
    priceT(val) {
      if (val) {
        return Number(val).toFixed(2);
      } else {
        return "0.00";
      }
    },
    boardroomLabel(code) {
      let val = ''
      switch (code) {
        case '1':
          val = '空调'
          break;
        case '2':
          val =  '投影仪'
          break;
        case '3':
          val = '无线WIFI'
          break;
        case '4':
          val =  '视频会议'
          break;
        case '5':
          val =  '白板'
          break;
        case '6':
          val =  '纸笔'
          break;
        case '7':
          val =  '茶水'
          break;
        case '8':
          val =  '停车场'
          break;
        default:
      }
      return val;


    }
  },
  created() {
    this.openRoom(this.$route.query.id);
  },
  activated() {
    this.isRoomActive = true;
    if (this.roomActivationCount++ > 0) this.openRoom(this.$route.query.id);
  },
  deactivated() {
    this.isRoomActive = false;
  },
  watch: {
    '$route.query.id'(id) {
      if (this.isRoomActive && this.$route.name === 'roomDetail' && id !== this.id) this.openRoom(id);
    }
  },
  methods: {
    openRoom(id) {
      this.id = id;
      this.viewRequestId = createViewRequestId(window.crypto);
      this.getMeetingRoomById();
    },
    recordView(meetingRoomId, viewRequestId, retriesLeft) {
      return recordViewWithRetry(recordMeetingRoomView, { meetingRoomId, viewRequestId }, retriesLeft)
        .then(recorded => {
          if (!recorded) console.warn('会议室浏览记录上报失败');
          return recorded;
        });
    },
    shareFun(){
      this.showIframe = true
    },
    hideIframe(){
      this.showIframe = false
    },
    previewImg() {},
    handleGallaryClose() {
      this.showGallary = false;
    },
    viewBigPic(imgPath) {
      this.roomInfo.images.forEach((item,index)=>{
        if(imgPath === item){
          this.curIndex = index
          this.showGallary = true;
        }
      })
    },
    playVideo() {
      var video = document.getElementById("video");
      video.play();
    },
    copyTradeCode() {
      var clipboard = new Clipboard(".btn_duplicate");
      clipboard.on("success", () => {
        util.showToast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
    },
    showMoreClick() {
      this.showMore = !this.showMore;
      this.showMoreText = this.showMoreText == "展开" ? "收起" : "展开";
    },
    callPhone() {
      if (this.roomInfo.consultingTel !== "") {
        window.location.href = "tel:" + this.roomInfo.consultingTel;
      } else {
        util.showToast("此会议室暂无咨询热线");
      }
    },
    getMeetingRoomById() {
      let that = this;
      const meetingRoomId = this.id;
      const viewRequestId = this.viewRequestId;
      getMeetingRoomById({
        meetingRoomId,
        queryDate: ""
      }).then(res => {
        if (viewRequestId !== this.viewRequestId) return;
        this.loaded = true
        console.log(res);
        if (res.res && res.res.code === 10000 && res.body && res.body.metingRoom) {
          this.isLock = res.body.metingRoom.isLock || 0;
          this.isDel = res.body.metingRoom.isDel || 0;
          if (res.body.metingRoom.describes.length > 50) {
            this.moreLenth = true;
          }
          this.roomInfo = res.body.metingRoom;
          this.meetingAgreementList =res.body.meetingAgreementList;
          this.isAgreement = res.body.isAgreement;
          if (this.roomInfo.imageList && this.roomInfo.imageList.length) {
            let imgs = [];
            this.roomInfo.imageList.forEach(item => {
              imgs.push(item.imgPath);
            });
            this.roomInfo.images = imgs;
          }
          this.payStatus = res.body.payStatus;
          this.chargeList = res.body.chargeList || [];
          this.rules = res.body.rules || [];
          if (res.body.metingRoom.freeFacilities) {
            this.labelList = res.body.metingRoom.freeFacilities.split(",");
          }
          this.$nextTick(() => {
            if (viewRequestId === this.viewRequestId) this.recordView(meetingRoomId, viewRequestId, 1);
          });
          let address = window.location.href.split('?')[0];
          wx.ready(()=>{
            let obj = {
              title: that.roomInfo.meetingRoomName, // 分享标题
              desc: '开放时段:'+that.roomInfo.beginTime + '-' + that.roomInfo.endTime + ';会议地址:' + that.roomInfo.address,
              link:address+'?id='+this.$route.query.id+'&marketId='+that.common.marketInfo.id+'&cityId='+that.common.cityId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.roomInfo.imageList[0].imgPath,// 分享图标
              success:function(){
                that.showIframe = false
                util.showToast('已分享')
              }
            }
            wx.onMenuShareAppMessage(obj)
            wx.onMenuShareTimeline(obj)
          })
        }else{
          this.isDel = 1
        }
      });
    },
    goForm() {
      if (!this.common.userId) {
        this.$router.push({
          path: "/login",
          query: {
            Rurl: `/roomDate/${this.roomInfo.id}`
          }
        });
      } else {
        if (this.payStatus != 1) {
          util.showToast(
            "你尚未开通该会议室的预订权限，请联系运营人员咨询。",
            2000
          );
        } else {
          this.$router.push({
            path: `/roomDate/${this.roomInfo.id}`
          });
        }
      }
    },

    openFile(file ,fileName){

      if(fileName.indexOf('png') > -1|| fileName.indexOf('jpg') > -1||fileName.indexOf('jpeg') > -1  ||fileName.indexOf('gif') > -1 ||fileName.indexOf('tif') > -1){
         localStorage.setItem("src", file);
         // 跳转地址
         this.$router.push(`/yuelanImage`);
        return;
      }
       if(fileName.indexOf('pdf') > -1){
            var url =serversHttp+ "servers.api/systemApi/exportFile?url="+encodeURIComponent(file)
            console.log(url);
            localStorage.setItem("src", url);
            localStorage.setItem("srcFlie", file);
          // 跳转地址
            var openUrl ='/yulanpdf?meetingRoomId='+this.roomInfo.id+"&isAgreement="+this.isAgreement +"&agreementName="+fileName
            this.$router.push(openUrl);
            return
        }
          // var url1 ="https://view.officeapps.live.com/op/view.aspx?src="+encodeURIComponent(file)
           var url1 ='http://view.xdocin.com/xdoc?_xdoc='+encodeURIComponent(file)
           console.log(url1);
           localStorage.setItem("src",url1);
           localStorage.setItem("srcFlie", file);
           var openUrl ='/iframePage?meetingRoomId='+this.roomInfo.id+"&isAgreement="+this.isAgreement +"&agreementName="+fileName
           this.$router.push(openUrl)

    }

  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background-color: @colore;
  
}
.noMess{
  .flex();
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height:90vh;
  img{
    display:block;
    width:280px;
    height:280px;
    margin-bottom:28px;
  }
  span{
    color:#999;
    font-size:32px;
    line-height:44px;
  }
}
.box {
  margin-bottom: 124px;
}
/*----------顶部banner图模块-------------*/
.top_swiper,
.swiper {
  height: 564px;
  width: 100%;
  position: relative;
  overflow: hidden;
}
.play_icon {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 33;
  transform: translate(-50%, -50%);
  width: 44px;
  height: 44px;
  padding: 32px;
  border-radius: 100%;
  background: rgba(0, 0, 0, 0.3);
}
.slide-image {
  width: 100%;
  height: 100%;
}
.indicator {
  position: absolute;
  bottom: 28px;
  right: 28px;
  height: 44px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
}
.icon_photos {
  width: 32px;
  height: 32px;
  margin-right: 20px;
}
.indicator span {
  font-size: 24px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}
.meetingRoomMsg {
  padding: 28px 28px 0;
  background: #fff;
  overflow: hidden;
  position: relative;
  .icon_share{
    display: block;
    position: absolute;
    right:0;
    top:0;
    width:44px;height:44px;
    padding:28px;
  }
}

.priceBox {
  height: 52px;
  padding-bottom: 8px;
  font-size: 28px;
  color: #333;
}

.sign {
  font-size: 32px;
  color: @colorfc;
  line-height: 52px;
}
.myVideo {
  width: 100%;
  height: 100%;
}
/*----------中间内容简介模块-------------*/
.activity_content {
  padding: 0 28px;
  background: #fff;
  margin-bottom: 14px;
}

.activity_num_box {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
  box-sizing: border-box;
}

.activity_num_box_left {
  display: flex;
}

.activity_num_see {
  font-size: 36px;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
  padding-bottom: 20px;
  font-weight: bold;
}

.activity_time_box,
.activity_address_box {
  display: flex;
  flex-direction: row;
  padding: 30px 0;
}
.activity_address_box {
  .borderT();
}

.activity_time_box_img {
  margin-top: 4px;
  width: 32px;
  height: 32px;
  margin-right: 14px;
  display: block;
}
.btn_duplicate {
  width: 44px;
  height: 44px;
}

.activity_time_box_text,
.activity_address_box_text {
  font-size: 26px;
  color: #333;
  line-height: 40px;
  flex: 1;
}
.activity_time_roomInfo {
  display: flex;
  padding-bottom: 28px;
  flex-direction: row;
  .borderB();
}

.activity_info_c {
  color: #999;
  font-size: 24px;
  line-height: 28px;
}

.activity_info_c1 {
  margin-right: 40px;
}

/*----------会议室简介模块-------------*/
.room_introduce {
  background-color: #fff;
  padding: 28px;
  margin-bottom: 14px;
}

.room_introduce_title_text {
  font-size: 32px;
  color: #333;
  line-height: 40px;
  margin-bottom: 20px;
  display: block;
  font-weight: bold;
}
.showMore {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 14px;
}
.showMore span {
  font-size: 24px;
  color: #333;
  line-height: 32px;
  display: block;
  margin-right: 8px;
}
.showMore img {
  display: block;
  width: 24px;
  height: 24px;
  transition: all ease-in-out 0.4s;
}
.room_introduce_html{
  
  width: 100%;
  display: flex;
    /deep/ strong {
      font-weight: bold;
      .fontSize(15px);
      line-height:  150%;
  }
  /deep/ p,
  /deep/ span {
      .fontSize(14px);
      color: rgba(0, 0, 0, 0.9);
      line-height: 150%;
  }
  /deep/ img {
      max-width: 100%;
      min-width: 40%;
      margin: 10px auto;
      height: auto;
      display: block;
  }
  /deep/ figcaption {
      text-align: center;
      .fontSize(14px);
      line-height:  150%;
  }
  /deep/ tr,
  td,
  th {
      .fontSize(14px);
  }

}
.room_introduce_content {
  font-size: 24px;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  padding: 10px;
  p {
    transition: all ease-in-out 0.4s;
  }
}
.linen {
  height: auto;
}
.rotate {
  transform: rotate(180deg);
}
/*----------服务设施模块-------------*/
.seviceList {
  display: flex;
  flex-wrap: wrap;
}

.item {
  width: 33.3%;
  height: 32px;
  line-height: 32px;
  font-size: 24px;
  color: #333;
  align-items: center;
  display: flex;
  margin-bottom: 14px;
  .seviceList_item {
    .flex();
    height: 32px;
    align-items: center;
    .seviceList_item_img {
      width: 22px;
      height: 16px;
      margin-right: 12px;
    }
    .seviceList_item_img_3{
      width: 44px;
      height: 44px;
      margin-right: 12px;
    }
    span {
      height: 32px;
      font-size: 24px;
      color: rgba(51, 51, 51, 1);
      line-height: 32px;
    }
  }
}

.seviceList_item_box_img {
  width: 20px;
  height: 16px;
  margin-right: 14px;
}

.seviceList_item_text {
  font-size: 24px;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
}

.activeRulesBox {
  // margin-top: 8px;
}
//协议
 .room_AgreementCard{
     padding-left: 28px;
     padding-top: 28px;
     padding-right: 28px;
     margin: 14px 0;
     background-color: #ffffff;
     position: relative;
  }
.room_Agreement_box{
  width:100%;
  height:100px;
  flex-direction: column;
  display: flex;
}
.room_Agreement_box1{
  width:100%;
  height:98px;
  flex-direction: row;
  align-items: center;
  display: flex;
}

.room_Agreement_icon{
  width: 40px;
  height: 40px;
  // s

}
.room_Agreement_span{
  margin-left: 14px;
  margin-right: 8px;
  display: flex;
  width:610px;
  height:40px;
  font-size:28px;
  font-weight:400;
  color:rgba(60,100,159,1);
  line-height:40px;
   display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
     white-space: pre-line;
}
.room_Agreement_icon1{
  width: 32px;
  height: 32px;
}
.room_Agreement_line{
  // margin-left: 28px;
  width:722px;
  height:2px;
  background:rgba(234,234,234,1);
}

.activeRules {
  font-size: 24px;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
}

/*----------底部按钮模块---------------*/
.bottom_box {
  height: 108px;
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  bottom: 0;
  padding: 0 32px;
  z-index: 2;
  width: 100%;
  box-sizing: border-box;
}
.bottom_box_big{
  justify-content: center;
}

.btn_zx {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 332px;
  height: 68px;
  box-sizing: border-box;
  .border(#96aaf0);
  border-radius: 4px;
  background: rgba(243, 245, 253, 1);
  font-size: 28px;
  color: @color17;
}
.btn_zx_big{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 664px;
  height: 68px;
  box-sizing: border-box;
  .border(#96aaf0);
  border-radius: 4px;
  background: rgba(243, 245, 253, 1);
  font-size: 28px;
  color: @color17;
}
.btn_color_3{
    color: #Dfcbb0;
    background:#ffffff;
    border: 0.015rem solid #Dfcbb0;
}
.pay_service {
  margin-top: 40px;
}
.ask_img {
  width: 32px;
  height: 32px;
  margin-right: 7px;
}

.btn_bm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 332px;
  height: 68px;
  background: @color17;
  border-radius: 4px;
  text-align: center;
  line-height: 68px;
  font-size: 28px;
  color: rgba(255, 255, 255, 1);
}
.btn_bm_color_3{
  color: #Dfcbb0;
  background: #000000;
}

.cantGo {
  width: 320px;
  height: 76px;
  background-color: #dadada;
  border-radius: 38px;
  font-size: 34px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 76px;
  text-align: center;
}
.bottom {
  padding-bottom: 68px;
}
/deep/ .swiper-pagination {
  color: #000;
  position: absolute;
  left: auto;
  right: 0.2rem;
  bottom: 0.2rem;
  display: inline-block;
  text-align: center;
  width: 0.92rem;
  height: 0.44rem;
  line-height: 0.44rem;
  color: #fff;
  font-size: 0.24rem;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0.04rem;
  .swiper-pagination-current {
    // font-size: 0.28rem !important;
  }
}
</style>

<!-- <style >
  /deep/ figure{
    max-width: 95%;
 }
  
</style> -->
